import React, { useEffect, useRef } from 'react';

import { setParameters, useTemplate } from '../../store/TemplateContext';
import { getCoreAPIUrl } from '../../helpers/urlHelper';
import { loggerError } from '../../helpers/logger';
import { useCommon } from '../../store/CommonContext';
import { getSearchParameter } from '../../helpers/location-helper';
import { useLocation, useNavigate } from 'react-router-dom';
import { sendAnswers, usePayment } from '../../store/PaymentContext';

interface Props {}

const Tokenex3DS: React.FC<Props> = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    state: { parameters },
    dispatch,
  } = useTemplate();
  const {
    dispatch: commonDispatch,
    state: { configuration },
  } = useCommon();
  const { dispatch: paymentDispatch } = usePayment();

  const form = useRef<HTMLFormElement>(null);
  const senseKey = getSearchParameter('senseKey');

  useEffect(() => {
    form.current?.submit();
  }, []);

  const fetchTokenex3dsStatus = () => {
    const url = `${getCoreAPIUrl('eligibility')}/threedsecure/${senseKey}/challenge_status`;

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      // body: JSON.stringify(body),
      // credentials: 'include',
    };

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return fetch(url, options)
      .then(res => res.json())
      .then(res => {
        if (res?.completed) {
          navigate({
            pathname: '/loader',
            search: location?.search,
          });
          sendAnswers({
            answers: {},
            dispatch: paymentDispatch,
            navigate,
            location,
            configuration,
            commonDispatch,
            templateDispatch: dispatch,
            customCallback: () => {
              setParameters(commonDispatch, {});
              navigate({
                pathname: '/challenge',
                search: location?.search,
              });
            },
          });
        } else {
          setTimeout(() => {
            fetchTokenex3dsStatus();
          }, 1000);
        }
      })
      .catch(error => {
        loggerError(error);
        setTimeout(() => {
          fetchTokenex3dsStatus();
        }, 1000);
      });
  };

  useEffect(() => {
    fetchTokenex3dsStatus();
  }, []);

  // if (!parameters.A) {
  //
  // }

  // if (!parameters.EncodedCReq || !parameters.AcsURL) {
  //   return <Loader />;
  // }

  return (
    <div className="">
      {/*<Loader />*/}
      <iframe name="challengeIframe" width={370} height={500} frameBorder={0} title="challengeIframe"></iframe>
      <form
        className=""
        id="challengeForm"
        action={parameters.AcsURL as string}
        target="challengeIframe"
        method="post"
        ref={form}
        onLoad={() => {
          console.log('3ds form loaded');
          form.current?.submit();
        }}
      >
        <input type="hidden" name="creq" id="creq" value={parameters.EncodedCReq as string} />

        <input type="hidden" name="threeDSSessionData" id="threeDSSessionData" />
      </form>
    </div>
  );
};

export default Tokenex3DS;
